//jacques-andre-editeur\JAEfrontend\src\screens\ShippingScreen.jsx

import { useState } from 'react';
import { Form, Button, Row, Col, Collapse, Card, ListGroup } from 'react-bootstrap';
import { FaChevronRight, FaChevronDown } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import FormContainer from '../components/FormContainer';
import { saveShippingAddress, clearCartItems } from '../slices/cartSlice';

import { useCreateOrderMutation } from '../slices/ordersApiSlice';

import StripeCheckout from '../components/StripeCheckout';
import { setOrderId } from '../slices/cartSlice';

const ShippingScreen = () => {

  const cart = useSelector((state) => state.cart);
  const { cartItems, shippingAddress } = cart;

  // calculs pour le résumé
  const totalItems = cartItems.reduce((acc, item) => acc + item.qty, 0);
  const totalItemsDisplay =
    totalItems > 1 ? totalItems + ' livres' : totalItems + ' livre';
  const totalPrice = cartItems
    .reduce((acc, item) => acc + item.qty * item.price, 0)
    .toFixed(2);

  // États pour chaque champ
  const [prenom, setPrenom] = useState(shippingAddress.prenom || '');
  const [nom, setNom] = useState(shippingAddress.nom || '');
  const [entreprise, setEntreprise] = useState(shippingAddress.entreprise || '');
  const [pays, setPays] = useState(shippingAddress.pays || '');
  const [rue, setRue] = useState(shippingAddress.rue || '');
  const [complement, setComplement] = useState(shippingAddress.complement || '');
  const [codePostal, setCodePostal] = useState(shippingAddress.codePostal || '');
  const [ville, setVille] = useState(shippingAddress.ville || '');
  const [telephonePortable, setTelephonePortable] = useState(shippingAddress.telephonePortable || '');
  const [telephoneFixe, setTelephoneFixe] = useState(shippingAddress.telephoneFixe || '');
  const [email, setEmail] = useState(shippingAddress.email || '');

  // États pour expédition alternative
  const [showShipping, setShowShipping] = useState(false);
  const [altPrenom, setAltPrenom] = useState('');
  const [altNom, setAltNom] = useState('');
  const [altEntreprise, setAltEntreprise] = useState('');
  const [altPays, setAltPays] = useState('');
  const [altRue, setAltRue] = useState('');
  const [altComplement, setAltComplement] = useState('');
  const [altCodePostal, setAltCodePostal] = useState('');
  const [altVille, setAltVille] = useState('');
  const [altTelephonePortable, setAltTelephonePortable] = useState('');
  const [altTelephoneFixe, setAltTelephoneFixe] = useState('');
  const [altEmail, setAltEmail] = useState('');



  const dispatch = useDispatch();
  const navigate = useNavigate();


const COUNTRIES = [
  "France","Afghanistan","Afrique du Sud","Albanie","Algérie","Allemagne","Andorre","Angola","Antigua-et-Barbuda","Arabie Saoudite",
  "Argentine","Arménie","Australie","Autriche","Azerbaïdjan","Bahamas","Bahreïn","Bangladesh","Barbade","Belgique","Belize",
  "Bénin","Bhoutan","Biélorussie","Birmanie","Bolivie","Bosnie-Herzégovine","Botswana","Brésil","Brunei","Bulgarie","Burkina Faso",
  "Burundi","Cambodge","Cameroun","Canada","Cap-Vert","Chili","Chine","Chypre","Colombie","Comores","Congo-Brazzaville",
  "Congo-Kinshasa","Corée du Nord","Corée du Sud","Costa Rica","Côte d’Ivoire","Croatie","Cuba","Danemark","Djibouti","Dominique",
  "Égypte","Émirats arabes unis","Équateur","Érythrée","Espagne","Estonie","Eswatini","États-Unis","Éthiopie",
  "Fidji","Finlande","Gabon","Gambie","Géorgie","Ghana","Grèce","Grenade","Guatemala","Guinée","Guinée-Bissau","Guinée équatoriale",
  "Guyana","Haïti","Honduras","Hongrie","Îles Cook","Îles Marshall","Îles Salomon","Inde","Indonésie","Irak","Iran","Irlande","Islande",
  "Israël","Italie","Jamaïque","Japon","Jordanie","Kazakhstan","Kenya","Kirghizistan","Kiribati","Koweït","Laos","Lesotho","Lettonie",
  "Liban","Libéria","Libye","Liechtenstein","Lituanie","Luxembourg","Macédoine du Nord","Madagascar","Malaisie","Malawi","Maldives",
  "Mali","Malte","Maroc","Maurice","Mauritanie","Mexique","Micronésie","Moldavie","Monaco","Mongolie","Monténégro","Mozambique",
  "Namibie","Nauru","Népal","Nicaragua","Niger","Nigeria","Norvège","Nouvelle-Zélande","Oman","Ouganda","Ouzbékistan","Pakistan",
  "Palaos","Panama","Papouasie-Nouvelle-Guinée","Paraguay","Pays-Bas","Pérou","Philippines","Pologne","Portugal","Qatar","Roumanie",
  "Royaume-Uni","Russie","Rwanda","Saint-Christophe-et-Niévès","Saint-Marin","Saint-Vincent-et-les-Grenadines","Sainte-Lucie",
  "Salvador","Samoa","Sao Tomé-et-Principe","Sénégal","Serbie","Seychelles","Sierra Leone","Singapour","Slovaquie","Slovénie",
  "Somalie","Soudan","Soudan du Sud","Sri Lanka","Suède","Suisse","Suriname","Syrie","Tadjikistan","Tanzanie","Tchad","Tchéquie",
  "Thaïlande","Timor oriental","Togo","Tonga","Trinité-et-Tobago","Tunisie","Turkménistan","Turquie","Tuvalu","Ukraine",
  "Uruguay","Vanuatu","Vatican","Venezuela","Vietnam","Yémen","Zambie","Zimbabwe"
];




  // Liste simplifiée des pays UE
  const EU_COUNTRIES = [
    'allemagne', 'espagne', 'italie', 'belgique',
    'pays-bas', 'portugal', 'autriche', 'irlande', 'finlande',
    'suède', 'danemark', 'pologne', 'grèce', 'hongrie',
    'tchéquie', 'slovaquie', 'slovénie', 'croatie', 'roumanie',
    'bulgarie', 'lituanie', 'lettonie', 'estonie', 'chypre',
    'luxembourg', 'malte'
  ];
  

  // // Logique frais hors UE
  // const normalizedCountry = pays.trim().toLowerCase();
  // const hasCountry = normalizedCountry.length > 0;
  // const isOutsideEU = hasCountry && !EU_COUNTRIES.includes(normalizedCountry);
  // const extraFee = isOutsideEU ? 3 : 0;
  // const totalWithFee = (parseFloat(totalPrice) + extraFee).toFixed(2);
  
  // Logique frais d'expédition
  // const normalizedCountry = pays.trim().toLowerCase();
  // let extraFee = 0;

  // if (normalizedCountry === 'france') {
  //   extraFee = 0;
  // } else if (EU_COUNTRIES.includes(normalizedCountry)) {
  //   extraFee = 3;
  // } else if (normalizedCountry.length > 0) {
  //   extraFee = 6;
  // }

  // const totalWithFee = (parseFloat(totalPrice) + extraFee).toFixed(2);
// Choix du pays de référence : celui de livraison s’il existe, sinon celui de facturation
const countryToCheck = showShipping && altPays.trim() ? altPays.trim().toLowerCase() : pays.trim().toLowerCase();

let extraFee = 0;
if (countryToCheck === 'france') {
  extraFee = 0;
} else if (EU_COUNTRIES.includes(countryToCheck)) {
  extraFee = 3;
} else if (countryToCheck.length > 0) {
  extraFee = 6;
}

const totalWithFee = (parseFloat(totalPrice) + extraFee).toFixed(2);


  // mutation RTK Query
  const [createOrder] = useCreateOrderMutation();

  const [orderCreated, setOrderCreated] = useState(null);

  const submitHandler = (e) => {
    e.preventDefault();
      
      const billing = {
        prenom,
        nom,
        entreprise,
        pays,
        rue,
        complement,
        codePostal,
        ville,
        telephonePortable,
        telephoneFixe,
        email,
      };

      let shipping = null;
      if (showShipping) {
        shipping = {
          prenom: altPrenom,
          nom: altNom,
          entreprise: altEntreprise,
          pays: altPays,
          rue: altRue,
          complement: altComplement,
          codePostal: altCodePostal,
          ville: altVille,
          telephonePortable: altTelephonePortable,
          telephoneFixe: altTelephoneFixe,
          email: altEmail,
        };
      }

      dispatch(saveShippingAddress({ billing, shipping }));

    createOrder({
        orderItems: cartItems,
        billingAddress: billing,
        shippingAddress: shipping,
        totalPrice: totalWithFee,
      })
    .unwrap()
    .then((res) => {
      dispatch(setOrderId(res._id));
      setOrderCreated(res._id);
    })
    .catch((err) => {
      console.error(err);
      alert('Erreur lors de la création de la commande');
    });


  };

  return (
    <FormContainer>
      {/* <CheckoutSteps step1 step2 /> */}

      {/* Cartouche récapitulatif du panier */}
      <Card className="mb-4">
        <Card.Body>
          <h2>Récapitulatif de vos achats ({totalItemsDisplay})</h2>
          <ListGroup variant="flush">
            {cartItems.map((item) => (
              <ListGroup.Item key={item._id}>
                <Row className="align-items-center">
                  <Col md={6}>
                    <Link to={`/livre/${item.slug}`}>{item.title}</Link>
                  </Col>
                  <Col md={2}>{item.price} €</Col>
                  <Col md={2}>x {item.qty}</Col>
                  <Col md={2} className="text-end">
                    {(item.price * item.qty).toFixed(2)} €
                  </Col>
                </Row>
              </ListGroup.Item>
            ))}
            {/* {isOutsideEU && (
              <ListGroup.Item>
                <Row>
                  <Col md={10}>Frais d'expédition hors UE</Col>
                  <Col md={2} className="text-end">3,00 €</Col>
                </Row>
              </ListGroup.Item>
            )} */}
            {extraFee > 0 && (
              <ListGroup.Item>
                <Row>
                  <Col md={10}>
                    <strong>Frais d'expédition</strong>
                  </Col>
                  <Col md={2} className="text-end">{extraFee.toFixed(2)} €</Col>
                </Row>
              </ListGroup.Item>
            )}




            <ListGroup.Item>
              <Row>
                <Col md={10}>
                  <strong>Total :</strong>
                </Col>
                <Col md={2} className="text-end">
                  <strong>{totalWithFee} €</strong>
                </Col>
              </Row>
            </ListGroup.Item>

          </ListGroup>
        </Card.Body>
      </Card>



      <Form onSubmit={submitHandler}>
        <Row>
          {/* Colonne gauche - Facturation */}
          <Col md={6}>
            <h2>Détails de facturation</h2>
            <Form.Group className="my-2" controlId="prenom">
              <Form.Label>Prénom *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Entrez votre prénom"
                value={prenom}
                required
                onChange={(e) => setPrenom(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="my-2" controlId="nom">
              <Form.Label>Nom *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Entrez votre nom"
                value={nom}
                required
                onChange={(e) => setNom(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="my-2" controlId="entreprise">
              <Form.Label>Nom de l’entreprise (facultatif)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ex : SARL Exemple"
                value={entreprise}
                onChange={(e) => setEntreprise(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="my-2" controlId="pays">
              <Form.Label>Pays *</Form.Label>
              <Form.Select
                value={pays}
                required
                onChange={(e) => setPays(e.target.value)}
              >
                <option value="">Sélectionnez votre pays</option>
                {COUNTRIES.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </Form.Select>
              {/* {isOutsideEU && (
                <small className="text-danger">
                  Des frais d'expédition de 3 € s'ajoutent pour les commandes hors de France mais en UE, et de 6 € hors UE
                </small>
              )} */}
              {extraFee > 0 && (
                <small className="text-danger">
                  {extraFee === 3
                    ? "Des frais d'expédition de 3 € s'ajoutent pour les commandes hors France mais en UE"
                    : "Des frais d'expédition de 6 € s'ajoutent pour les commandes hors UE"}
                </small>
              )}

            </Form.Group>

            <Form.Group className="my-2" controlId="rue">
              <Form.Label>Numéro et nom de rue *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ex : 12 rue de la République"
                value={rue}
                required
                onChange={(e) => setRue(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="my-2" controlId="complement">
              <Form.Label>Appartement, suite, unité… (facultatif)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ex : Bâtiment B, 3e étage"
                value={complement}
                onChange={(e) => setComplement(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="my-2" controlId="codePostal">
              <Form.Label>Code postal *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ex : 75001"
                value={codePostal}
                required
                onChange={(e) => setCodePostal(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="my-2" controlId="ville">
              <Form.Label>Ville *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ex : Paris"
                value={ville}
                required
                onChange={(e) => setVille(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="my-2" controlId="telephonePortable">
              <Form.Label>Téléphone portable *</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Ex : 0612345678"
                value={telephonePortable}
                required
                onChange={(e) => setTelephonePortable(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="my-2" controlId="telephoneFixe">
              <Form.Label>Téléphone fixe</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Ex : 0145678910"
                value={telephoneFixe}
                onChange={(e) => setTelephoneFixe(e.target.value)}
              />
            </Form.Group>


            <Form.Group className="my-2" controlId="email">
              <Form.Label>E-mail *</Form.Label>
              <Form.Control
                type="email"
                placeholder="exemple@mail.com"
                value={email}
                required
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
          </Col>

          {/* Colonne droite - Expédition alternative */}
          <Col md={6}>
            <h2
              onClick={() => setShowShipping(!showShipping)}
              aria-controls="shipping-form"
              aria-expanded={showShipping}
            >
              {showShipping ? (
                <FaChevronDown className="me-3" />
              ) : (
                <FaChevronRight className="me-3" />
              )}
              {showShipping ? "Adresse de livraison" : "Expédier à une autre adresse ?"}
            </h2>

            <Collapse in={showShipping}>
              <div id="shipping-form">

                <Form.Group className="my-2" controlId="altPrenom">
                  <Form.Label>Prénom *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Entrez le prénom"
                    value={altPrenom}
                    required={showShipping}
                    onChange={(e) => setAltPrenom(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="my-2" controlId="altNom">
                  <Form.Label>Nom *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Entrez le nom"
                    value={altNom}
                    required={showShipping}
                    onChange={(e) => setAltNom(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="my-2" controlId="altEntreprise">
                  <Form.Label>Nom de l’entreprise (facultatif)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ex : SARL Exemple"
                    value={altEntreprise}
                    onChange={(e) => setAltEntreprise(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="my-2" controlId="altPays">
                  <Form.Label>Pays *</Form.Label>
                  <Form.Select
                    value={altPays}
                    required={showShipping}
                    onChange={(e) => setAltPays(e.target.value)}
                  >
                    <option value="">Sélectionnez votre pays</option>
                    {COUNTRIES.map((c) => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </Form.Select>
                  {/* {isOutsideEU && (
                    <small className="text-danger">
                      Des frais d'expédition de 3 € s'ajoutent pour les commandes hors de France mais en UE, et de 6 € hors UE
                    </small>
                  )} */}
                  {extraFee > 0 && (
                    <small className="text-danger">
                      {extraFee === 3
                        ? "Des frais d'expédition de 3 € s'ajoutent pour les commandes hors France mais en UE"
                        : "Des frais d'expédition de 6 € s'ajoutent pour les commandes hors UE"}
                    </small>
                  )}
                  
                </Form.Group>
                <Form.Group className="my-2" controlId="altRue">
                  <Form.Label>Numéro et nom de rue *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ex : 45 avenue Victor Hugo"
                    value={altRue}
                    required={showShipping}
                    onChange={(e) => setAltRue(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="my-2" controlId="altComplement">
                  <Form.Label>Appartement, suite, unité… (facultatif)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ex : Appt 12"
                    value={altComplement}
                    onChange={(e) => setAltComplement(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="my-2" controlId="altCodePostal">
                  <Form.Label>Code postal *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ex : 69001"
                    value={altCodePostal}
                    required={showShipping}
                    onChange={(e) => setAltCodePostal(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="my-2" controlId="altVille">
                  <Form.Label>Ville *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ex : Lyon"
                    value={altVille}
                    required={showShipping}
                    onChange={(e) => setAltVille(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="my-2" controlId="altTelephonePortable">
                  <Form.Label>Téléphone portable</Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="Ex : 0611223344"
                    value={altTelephonePortable}
                    required={showShipping}
                    onChange={(e) => setAltTelephonePortable(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="my-2" controlId="altTelephoneFixe">
                  <Form.Label>Téléphone fixe</Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="Ex : 0144556677"
                    value={altTelephoneFixe}
                    onChange={(e) => setAltTelephoneFixe(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="my-2" controlId="altEmail">
                  <Form.Label>E-mail de livraison *</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="exemple@mail.com"
                    value={altEmail}
                    required={showShipping}
                    onChange={(e) => setAltEmail(e.target.value)}
                  />
                </Form.Group>

              </div>
            </Collapse>
          </Col>

        </Row>


        <Button type="submit" variant="primary" className="mt-3">
          Valider l'adresse et procéder au paiement
        </Button>
      </Form>

        {orderCreated && (
          <StripeCheckout orderId={orderCreated} />
        )}
    </FormContainer>
    
  );
};

export default ShippingScreen;
